import './style.less';

export default function($log, $state, ProfileClass, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company_id, formsActive } = ProfileClass.profileComplete.company;

  /**
   * Submits company forms settings data
   */
  vm.submit = formData => {
    vm.submitButton = true;

    ApiClass.companiesIdPatch({ manage: true, id: company_id }, { formsActive: formData.formsActive })
      .then(() => {
        Swal.toast('Forms information has been saved');
        vm.submitButton = false;
        $state.go('^');
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  /**
   * Bootstrap function - decides what fields to display based on the state, defaults
   * to a patch state, then calls the function to load the data for that integration
   * from the API.
   */
  function activate() {
    $log.debug('Forms Edit Controller Activated');
    vm.submitButton = false;
    vm.formData = { formsActive };
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/forms/index.js